//AUTH TYPES
export const REGISTRO_EXITOSO = "REGISTRO_EXITOSO"
export const REGISTRO_ERROR = "REGISTRO_ERROR"
export const LOGIN_EXITOSO = "LOGIN_EXITOSO"
export const LOGIN_ERROR = "LOGIN_ERROR"
export const LOGOUT = "LOGOUT"
export const OBTENER_USUARIO = "OBTENER_USUARIO"
export const MODIFICAR_USUARIO = "MODIFICAR_USUARIO"
export const OBTENER_USUARIO_ERROR = "OBTENER_USUARIO_ERROR"
export const VALIDAR_CUENTA_EXITOSA = "VALIDAR_CUENTA_EXITOSA"
export const VALIDAR_CUENTA_ERROR = "VALIDAR_CUENTA_ERROR"
export const GET_PROYECTOS = "GET_PROYECTOS"
export const ERROR_USUARIO = "ERROR_USUARIO"
export const ADD_TO_FAVORITES_SUCCESS = "ADD_TO_FAVORITES_SUCCESS"
export const ON_UPLOAD_PROJECT = "ON_UPLOAD_PROJECT"
export const UPLOAD_PROJECT_SUCCESS = "UPLOAD_PROJECT_SUCCESS"
export const UPLOAD_PROJECT_ERROR = "UPLOAD_PROJECT_ERROR"
export const ON_CREATE_PROJECT = "ON_CREATE_PROJECT"
export const CREATE_PROJECT_SUCCESS = "CREATE_PROJECT_SUCCESS"
export const CREATE_PROJECT_ERROR = "CREATE_PROJECT_ERROR"
export const ON_GET_PROJECTS = "ON_GET_PROJECTS"
export const ON_GET_CHAPTERS = "ON_GET_CHAPTERS"
export const GET_PROJECTS_SUCCESS = "GET_PROJECTS_SUCCESS"
export const GET_CHAPTERS_SUCCESS = "GET_CHAPTERS_SUCCESS"
export const GET_PROJECTS_ERROR = "GET_PROJECTS_ERROR"
export const ON_GET_PROJECT = "ON_GET_PROJECT"
export const GET_PROJECT_SUCCESS = "GET_PROJECT_SUCCESS"
export const GET_PROJECT_ERROR = "GET_PROJECT_ERROR"
export const UPDATE_PROJECT_SUCCESS = "UPDATE_PROJECT_SUCCESS"
export const DELETE_CHAPTERS_SUCCESS = "DELETE_CHAPTERS_SUCCESS"
export const DELETE_PARTIDA_SUCCESS = "DELETE_PARTIDA_SUCCESS"
export const DELETE_PROJECT_SUCCESS = "DELETE_PROJECT_SUCCESS"
export const CLEAR_UPLOAD_PROCESS = "CLEAR_UPLOAD_PROCESS"
export const GET_CHAPTERS_BUDGET_SUCCESS = "GET_CHAPTERS_BUDGET_SUCCESS"
export const CHANGE_SEND_BUDGET = "CHANGE_SEND_BUDGET"
export const SENDING_MESSAGE = "SENDING_MESSAGE"
export const SEND_COMPLETE = "SEND_COMPLETE"
//FILE ACTIONS
export const GET_URL_POST = "GET_URL_POST"
export const GET_URL_POST_SUCCESS = "GET_URL_POST_SUCCESS"
export const GET_URL_POST_ERROR = "GET_URL_POST_ERROR"
export const ON_UPLOADING_FILE = "ON_UPLOADING_FILE"
export const UPLOAD_FILE_SUCCESS = "UPLOAD_FILE_SUCCESS"
export const UPLOAD_FILE_ERROR = "UPLOAD_FILE_ERROR"
export const GET_MY_FILES = "GET_MY_FILES"
export const GET_MY_FILES_SUCCESS = "GET_MY_FILES_SUCCESS"
export const GET_MY_FILES_ERROR = "GET_MY_FILES_ERROR"
export const UPLOADING_FILE = "UPLOADING_FILE"

export const ON_GET_PROPOSAL = "ON_GET_PROPOSAL"
export const GET_PROPOSAL_SUCCESS = "GET_PROPOSAL_SUCCESS"
export const GET_PROPOSAL_ERROR = "GET_PROPOSAL_ERROR"
export const UPDATE_PART = "UPDATE_PART"
export const GET_GROUP_PROPOSAL_SUCCESS = "GET_GROUP_PROPOSAL_SUCCESS"
export const LOADING_PDF = "LOADING_PDF"
export const GET_PDF_SUCCESS = "GET_PDF_SUCCESS"
export const LOADING_TABLA_COMPARATIVA = "LOADING_TABLA_COMPARATIVA"
export const GET_TABLA_COMPARATIVA_SUCCESS = "GET_TABLA_COMPARATIVA_SUCCESS"

export const GET_CONTACT_SUCCESS = "GET_CONTACT_SUCCESS"

export const RESET_SEND = "RESET_SEND"
export const GET_VERSIONS_SUCCESS = "GET_VERSIONS_SUCCESS"

export const WORKER_CREATED = "WORKER_CREATED"
export const GET_WORKERS_BY_PROJECT = "GET_WORKERS_BY_PROJECT"
export const WORKER_UPDATED = "WORKER_UPDATED"

export const GET_TASKS_BY_PROJECT = "GET_TASKS_BY_PROJECT"
export const ADD_COLUMN = "ADD_COLUMN"
export const DELETE_COLUMN = "DELETE_COLUMN"
export const UPDATE_COLUMN = "UPDATE_COLUMN"
export const UPDATE_TASK = "UPDATE_TASK"
export const CREATE_GANTT = "CREATE_GANTT"
export const UPDATE_FILTER = "UPDATE_FILTER"

// acts
export const SET_SELECTED_ACTA = "SET_SELECTED_ACTA"
export const GET_ACTS = "GET_ACTS"
export const GET_ACTA = "GET_ACTA"
export const ADD_ACT = "ADD_ACT"
export const UPDATE_ACT = "UPDATE_ACT"
export const DELETE_ACT = "DELETE_ACT"
export const UPDATE_PENDING_SUBJECT = "UPDATE_PENDING_SUBJECT"

//bankPrices
export const GET_BANK_PRICES = "GET_BANK_PRICES"
export const LOADING_BANKPRICES = "LOADING_BANKPRICES"
export const LOADING_SUBCAPS = "LOADING_SUBCAPS"

export const SET_FOOTER_VALUES = "SET_FOOTER_VALUES"

export const DEL_CAPITULO_SET_POSITION = "DEL_CAPITULO_SET_POSITION"

export const SET_BC3_LINK_DATA = "SET_BC3_LINK_DATA"
export const TOGGLE_MODAL_IMPORT_BC3_LINK = "TOGGLE_MODAL_IMPORT_BC3_LINK"
export const IS_IMPORTING_PART_FROM_EDIT_MODAL =
  "IS_IMPORTING_PART_FROM_EDIT_MODAL"
export const SET_MODAL_BUDGETING_ERROR = "SET_MODAL_BUDGETING_ERROR"
export const REMOVE_ALL_PARTS_FROM_CHAPTER = "REMOVE_ALL_PARTS_FROM_CHAPTER"
export const SET_CHAPTER_ID_SELECTED_FROM_BC3LINK =
  "SET_CHAPTER_ID_SELECTED_FROM_BC3LINK"

// Certification history
export const SET_CERTIFICATION_HISTORY_TREE = "SET_CERTIFICATION_HISTORY_TREE"
export const SET_LOADING = "SET_LOADING"
export const SET_DOWNLOAD_BUDGET_LOADING = "SET_DOWNLOAD_BUDGET_LOADING"
export const SET_OPEN_EXPORT_SIDEBAR = "SET_OPEN_EXPORT_SIDEBAR"
export const CALCULATE_ALL_TOTAL_CERT_PRICES = "CALCULATE_ALL_TOTAL_CERT_PRICES"
export const SET_SELECTED_CERTIFICATION_ID = "SET_SELECTED_CERTIFICATION_ID"
export const ON_UPDATE = "ON_UPDATE"
export const SET_CERT_TO_DELETE = "SET_CERT_TO_DELETE"
export const DELETE_CERTIFICATION_BY_ID = "DELETE_CERTIFICATION_BY_ID"

export const IS_CONTRADICTING_PART = "IS_CONTRADICTING_PART"
export const SET_PART_ID = "SET_PART_ID"
export const EXTRA_AND_CONTRADITIONS_PART_ID_IS_CHECKED =
  "EXTRA_AND_CONTRADITIONS_PART_ID_IS_CHECKED"
export const SET_TREE = "SET_TREE"
export const SET_ERROR = "SET_ERROR"
export const TOGGLE_DELETE_PART_MODAL = "TOGGLE_DELETE_PART_MODAL"
export const REMOVE_PART = "REMOVE_PART"
export const MOVE_PART = "MOVE_PART"
export const REASSIGN_PART_POSITIONS = "REASSIGN_PART_POSITIONS"
export const SET_OPEN_NEW_MODAL_PART = "SET_OPEN_NEW_MODAL_PART"
export const SET_BTN_LOADING = "SET_BTN_LOADING"
export const SET_LOADING_ICON = "SET_LOADING_ICON"
export const IS_BUDGET_CLOSED = "IS_BUDGET_CLOSED"
export const SET_CLOSE_INFO = "SET_CLOSE_INFO"
export const MOVE_PARTS_BY_CHAPTERS_ID = "MOVE_PARTS_BY_CHAPTERS_ID"

export const SET_ALL_DYNAMIC_ELEMENTS = "SET_ALL_DYNAMIC_ELEMENTS"
export const SET_ALL_DYNAMIC_ELEMENTS_TO_INITIAL_STATE =
  "SET_ALL_DYNAMIC_ELEMENTS_TO_INITIAL_STATE"
export const ADD_DYNAMIC_ELEMENT = "ADD_DYNAMIC_ELEMENT"
export const DELETE_DYNAMIC_ELEMENT = "DELETE_DYNAMIC_ELEMENT"
export const EDIT_DYNAMIC_ELEMENT = "EDIT_DYNAMIC_ELEMENT"
export const SET_IS_FROM_PROJECT = "SET_IS_FROM_PROJECT"
export const SET_OPEN_CONFIRM_DELETE_MODAL = "SET_OPEN_CONFIRM_DELETE_MODAL"
export const SET_ELEMENT_TO_DELETE = "SET_ELEMENT_TO_DELETE"
export const SET_IS_HOW_TO_ADD_MODAL_OPEN = "SET_IS_HOW_TO_ADD_MODAL_OPEN"
export const SET_DYNAMIC_ELEMENT_MODAL_IS_OPEN =
  "SET_DYNAMIC_ELEMENT_MODAL_IS_OPEN"
export const SET_DYNAMIC_ELEMENT_SELECTED = "SET_DYNAMIC_ELEMENT_SELECTED"
export const SET_DYNAMIC_ELEMENT_PROJECT_ID = "SET_DYNAMIC_ELEMENT_PROJECT_ID"
export const SET_PARTS_RELATED_TO_ELEMENT_TO_DELETE =
  "SET_PARTS_RELATED_TO_ELEMENT_TO_DELETE"
export const SET_GENERAL_UPDATE = "SET_GENERAL_UPDATE"
export const CERTIFICATION_LOADING = "CERTIFICATION_LOADING"
export const SET_CHAPTER_CERT_IN_PROGRESS = "SET_CHAPTER_CERT_IN_PROGRESS"
export const CERT_DRAFT_SET_PARTIDA = "CERT_DRAFT_SET_PARTIDA"
export const SET_NEW_MODAL_PART_STATE = "SET_NEW_MODAL_PART_STATE"
export const SET_BC3_LINK_STATE = "SET_BC3_LINK_STATE"
export const SET_PART_BROWSER_STATE = "SET_PART_BROWSER_STATE"

export const IS_NEW_PART = "isNewPart"
export const NEW_MODAL_PARTIDA = "NewModalPartida"
export const NEW_STRUCTURE = "Estructura New"
export const WRAPPER_MODALS = "wrapper modals"
export const EXTRAS_AND_CONTRADICTIONS = "extras and contradictions"

export const SET_TEMPLATES = "SET_TEMPLATES"
export const ADD_TEMPLATE = "ADD_TEMPLATE"
export const UPDATE_TEMPLATE = "UPDATE_TEMPLATE"
export const DELETE_TEMPLATE = "DELETE_TEMPLATE"
export const SET_EDIT_TEMPLATE = "SET_EDIT_TEMPLATE"
export const SET_DELETE_TEMPLATE = "SET_DELETE_TEMPLATE"

export const SET_INITIAL_MARGIN_DATA = "SET_INITIAL_MARGIN_DATA"
export const SET_TOTAL_MARGIN = "SET_TOTAL_MARGIN"
export const SET_OVERWRITE_MARGIN = "SET_OVERWRITE_MARGIN"
export const SET_OVERWRITE_COST_REDUCTION = "SET_OVERWRITE_COST_REDUCTION"
export const SET_OVERWRITE_MARGIN_EXTRA = "SET_OVERWRITE_MARGIN_EXTRA"
export const SET_GENERAL_EXPENSES = "SET_GENERAL_EXPENSES"
export const SET_INDIRECT_EXPENSES = "SET_INDIRECT_EXPENSES"
export const SET_INDUSTRIAL_PROFIT = "SET_INDUSTRIAL_PROFIT"
export const SET_ADD_EXTRA_PERCENTAGE = "SET_ADD_EXTRA_PERCENTAGE"
export const SET_GENERAL_DISCOUNT = "SET_GENERAL_DISCOUNT"
export const SET_ADD_EXTRA_DISCOUNT_PERCENTAGE =
  "SET_ADD_EXTRA_DISCOUNT_PERCENTAGE"
export const SET_OVERRIDE_DISCOUNTS = "SET_OVERRIDE_DISCOUNTS"
export const SET_IS_CLIENT_PRICE = "SET_IS_CLIENT_PRICE"
export const SET_ACCORDION_SELECTED = "SET_ACCORDION_SELECTED"
export const SET_DISCOUNT_ACCORDION_SELECTED = "SET_DISCOUNT_ACCORDION_SELECTED"
export const SET_TAB = "SET_TAB"
export const SET_MARGIN_MODAL = "SET_MARGIN_MODAL"
export const SET_MARGIN_MODAL_INITIAL_VALUE = "SET_MARGIN_MODAL_INITIAL_VALUE"
export const LOADING = "LOADING"
export const SET_FORMULA = "SET_FORMULA"
export const SET_INITIAL_RIGHT_FOOTER_DATA = "SET_INITIAL_RIGHT_FOOTER_DATA"
export const SET_RIGHT_FOOTER = "SET_RIGHT_FOOTER"
export const SET_MARGIN_PERCENT = "SET_MARGIN_PERCENT"
export const SET_UNIT_PRICE = "SET_UNIT_PRICE"
export const SET_MARGIN_EURO = "SET_MARGIN_EURO"
export const SET_TOTAL_PRICE = "SET_TOTAL_PRICE"
export const SET_PARTIDA = "SET_PARTIDA"
export const SET_PARTIDA_VALUE = "SET_PARTIDA_VALUE"
export const SET_QUANTITY = "SET_QUANTITY"
export const SET_INITIAL_VALUES = "SET_INITIAL_VALUES"
export const SET_COST = "SET_COST"
export const SET_TOTAL_COST = "SET_TOTAL_COST"
export const SET_COST_REDUCTION = "SET_COST_REDUCTION"
export const SET_PRICE_REDUCED = "SET_PRICE_REDUCED"
export const SET_PRICE_PREREDUCED = "SET_PRICE_PREREDUCED"
export const SET_EURO_REDUCED = "SET_EURO_REDUCED"
export const SET_TOTAL_REDUCED = "SET_TOTAL_REDUCED"
export const SET_DISCOUNT_PERCENTAGE = "SET_DISCOUNT_PERCENTAGE"
export const SET_DISCOUNT_AMOUNT = "SET_DISCOUNT_AMOUNT"
export const SET_UNIT_PRICE_WITH_DISCOUNT = "SET_UNIT_PRICE_WITH_DISCOUNT"
export const SET_TOTAL_PRICE_WITH_DISCOUNT = "SET_TOTAL_PRICE_WITH_DISCOUNT"
